import React from 'react'
import { useSelector } from 'react-redux'

import { calculateImpressionsFromBudget } from '../../../../UploadAdCreative/ImpressionsBudgetSection/helpers'

import { rightSelector } from '../../../../../../modules/selectors/rights'

import { BUDGET } from '../../../../../Tiktok/CampaignForms/CampaignTikTokEdit/fields'

const TikTokCampaignImpressionsBudgetPreview = ({ campaign }) => {
  const { bid_cap: rightBidCap } = useSelector(rightSelector)

  const impressions = calculateImpressionsFromBudget({
    budget: campaign?.[BUDGET],
    rightBidCap
  })

  return <p>{impressions}</p>
}

export default TikTokCampaignImpressionsBudgetPreview
